export default __webpack_public_path__ + "static/media/lacessories15.d70f9653.jpeg";